import { h } from '@atomify/jsx';

const MapLabel = ({
    title,
    subtitle,
    classes,
}: {
    title?: string;
    subtitle?: string | Text;
    classes?: string;
}) => (
    <div class={`c-map-label ${classes || ''}`}>
        {title && <div class="map-label__title">{title}</div>}
        {subtitle && <div class="map-label__subtitle">{subtitle}</div>}
    </div>
);

export { MapLabel };
